<template>
  <div class="plugin-wrap detail_multi_lines layout" v-if="config && Array.isArray(config.lines)">
    <div class="ms-row center-xs">
      <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6">
        <div class="m-product-details__ingredients-inner">
          <div class="m-product-details__ingredients-short">
            <!-- <div class="">{{config.title}}</div> -->
            <ul class="disc-bullet">
              <li v-for="(item, index) in config.lines" :key="index">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductDetailText",
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .disc-bullet {
    list-style: disc inside;
    li { list-style-type: disc; }
  }
  .m-product-details__ingredients-inner {
    background: #fff;
  }
  .m-product-details__ingredients-short {
    color: #000;
    padding: 2.1875rem 0 0;
  }
  @media screen and (min-width: 48em) {
    .m-product-details__ingredients-inner {
      padding: 0 3.4375rem 5.625rem .9375rem;
    }
    .m-product-details__ingredients-short {
      padding: 2.5rem 0 0;
    }
  }

  @media screen and (min-width: 64em) {
    .m-product-details__ingredients-inner {
      padding: 0 4.375rem 5.625rem 0;
    }
  }

  @media screen and (min-width: 75em) {
    .m-product-details__ingredients-inner {
      padding: 0 6.25rem 5rem 0;
    }
  }
</style>